// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import FieldDropdown from '../FieldDropdown';
import PriceRangeFields from './PriceRangeFields';
import { addThousandSeparator } from '%/utils/filters/usedVehicles/portalUsedVehiclesV2/makeFiltersPillData';

class PriceRange extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handlePriceChange(filterKey) {
    return (event) => {
      const value = event.target.value
      const parsedValue = value.replace(/\./g, '')
      
      this.props.handleUpdateFilter(filterKey, parsedValue);
    }
  }

  handleInputChange(event) {
    let value = event.target.value
    value = value.replace(/[^\d.]/g, '')

    const cleanValue = value.replace(/\./g, '')
    const parsedValue = addThousandSeparator(cleanValue)
    
    event.target.value = parsedValue
  }
  
  render() {
    const { currentMinPrice, currentMaxPrice } = this.props;

    return ( 
      <FieldDropdown
        fieldTitle="Faixa de preço"
        customClasses="price-range only-desktop"
        dropdownCustomClasses="price-range__dropdown"
      >
        <h4 className="filter-v2__dropdown-title">Faixa de preço</h4>
        <PriceRangeFields
          handleInputChange={this.handleInputChange}
          handleMinPriceChange={this.handlePriceChange('min_price')}
          handleMaxPriceChange={this.handlePriceChange('max_price')}
          currentMinPrice={addThousandSeparator(currentMinPrice)}
          currentMaxPrice={addThousandSeparator(currentMaxPrice)}
        />
      </FieldDropdown>
    );
  }
}

PriceRange.defaultProps = {
  currentMinPrice: null,
  currentMaxPrice: null,
  handleUpdateFilter: () => {},
};

PriceRange.propTypes = {
  currentMinPrice: PropTypes.number,
  currentMaxPrice: PropTypes.number,
  handleUpdateFilter: PropTypes.func,
};

export default PriceRange;
